import { render, staticRenderFns } from "./GameCreate.vue?vue&type=template&id=37674bb0&"
import script from "./GameCreate.vue?vue&type=script&lang=js&"
export * from "./GameCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports